// import { getCommonParamsOptions } from '@/utils/common'

export const searchFormConfig = {
  labelWidth: '160px',
  itemStyle: {
    padding: '5px 20px'
  },
  formItems: [
    {
      field: 'name',
      type: 'input',
      label: 'user.resource-group-name'
    },
    {
      field: 'description',
      type: 'input',
      label: 'user.resource-group-desc'
    },
    {
      field: 'createTime',
      type: 'datepicker',
      label: 'general.creation-date',
      otherOptions: {
        type: 'daterange'
      },
      dateFieldName: ['startDateTime', 'endDateTime']
    }
    // {
    //   field: 'status',
    //   type: 'select',
    //   label: 'general.status',
    //   isResolveGlobalParams: true,
    //   options: [],
    //   handler: () => getCommonParamsOptions('status')
    // }
  ]
}
